import React from 'react';
import { Skeleton, TableBody, TableCell, TableRow } from '@razorpay/blade/components';

export const SkeletonTableBody = ({
  rowCount,
  columnCount,
}: {
  rowCount: number;
  columnCount: number;
}) => {
  return (
    <>
      <TableBody>
        {Array(rowCount)
          .fill(0)
          .map((_, rowIndex) => (
            <TableRow key={rowIndex} item={{ id: rowIndex }}>
              {Array(columnCount)
                .fill(0)
                .map(() => (
                  <TableCell>
                    <Skeleton width="100%" height={'80%'} borderRadius="medium" />
                  </TableCell>
                ))}
            </TableRow>
          ))}
      </TableBody>
    </>
  );
};
